import React, { useEffect, useRef, useState } from 'react'
import { FiPlusSquare } from 'react-icons/fi'
import styled, { css } from 'styled-components'

const CommonImageUpload = ({ image, onChange }) => {
  return (
    <FlexContainer className="image-uploaded">
      <label htmlFor="upload" ref={image}>
        <Wrapper>
          <FiPlusSquare />
        </Wrapper>
        <input
          type="file"
          id="upload"
          accept="img/*"
          onChange={onChange}
          style={{ display: 'none' }}
        />
      </label>
    </FlexContainer>
  )
}

const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

const FlexContainer = styled.div`
  ${flexCenter}
`
const Wrapper = styled.div`
  ${flexCenter}
  border: 1px solid #eeeeee;
  width: 320px;
  height: 200px;
  cursor: pointer;
`

export default CommonImageUpload
